// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-edit-phase-validation-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.tournament-edit-phase-validation-modal .hubicon-info {
    font-size: var(--space-x2);
    margin-top: var(--space-and-half);
}

.tournament-edit-phase-validation-modal .baloa-normal-text {
    margin: var(--space-x2) 0;
    color: var(--primary-very-dark-color);
    padding: 0 var(--space-and-half);
    text-align: center;
}

.tournament-edit-phase-validation-modal__container .modal__container {
    padding: 0;
    max-width: 365px;
}

.tournament-edit-phase-validation-modal__action-btn {
    padding: var(--space-half-quarter) 0;
    border-top: 1px solid var(--new-input-background-color);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.tournament-edit-phase-validation-modal__phase_actions__btns {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: var(--space-half-quarter) var(--space);
    border-top: 1px solid var(--new-input-background-color);
}

.tournament-edit-phase-validation-modal__phase_actions__btns .button {
    padding: var(--space-half) calc( var(--space) + var(--space-quarter) );
    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);
    line-height: calc(var(--space) + var(--space-eighth));
}

.tournament-edit-phase-validation-modal__phase_actions__btns .secondary-button {
    border: none;
    color: var(--primary-dark-color);
}

.tournament-edit-phase-validation-modal__phase_actions__btns .secondary-button:hover {
    background-color: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-edit-phase-validation-modal/TournamentEditPhaseValidationModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uDAAuD;IACvD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,+CAA+C;IAC/C,uDAAuD;AAC3D;;AAEA;IACI,sEAAsE;IACtE,sEAAsE;IACtE,qDAAqD;AACzD;;AAEA;IACI,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".tournament-edit-phase-validation-modal {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-edit-phase-validation-modal .hubicon-info {\n    font-size: var(--space-x2);\n    margin-top: var(--space-and-half);\n}\n\n.tournament-edit-phase-validation-modal .baloa-normal-text {\n    margin: var(--space-x2) 0;\n    color: var(--primary-very-dark-color);\n    padding: 0 var(--space-and-half);\n    text-align: center;\n}\n\n.tournament-edit-phase-validation-modal__container .modal__container {\n    padding: 0;\n    max-width: 365px;\n}\n\n.tournament-edit-phase-validation-modal__action-btn {\n    padding: var(--space-half-quarter) 0;\n    border-top: 1px solid var(--new-input-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.tournament-edit-phase-validation-modal__phase_actions__btns {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 100%;\n    padding: var(--space-half-quarter) var(--space);\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.tournament-edit-phase-validation-modal__phase_actions__btns .button {\n    padding: var(--space-half) calc( var(--space) + var(--space-quarter) );\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth) + 1px);\n    line-height: calc(var(--space) + var(--space-eighth));\n}\n\n.tournament-edit-phase-validation-modal__phase_actions__btns .secondary-button {\n    border: none;\n    color: var(--primary-dark-color);\n}\n\n.tournament-edit-phase-validation-modal__phase_actions__btns .secondary-button:hover {\n    background-color: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
